export default __webpack_public_path__ + "static/media/Dad_Business_Struggle_3_2.f68419a3.png";